<template>
  <div id="app">
    <transition :name="transitionName">
      <router-view v-slot="{ Component }">
          <component :is="Component" />
      </router-view>
    </transition>
  </div>
</template>

<script>

export default {
  name: 'App',
  watch: {
    $route (to, from) {
      // 如果to索引大于from索引,判断为前进状态,反之则为后退状态
      console.log(to, 'to')
      console.log(from, 'from')
      if (to.meta.title) {
        document.title = to.meta.title
      }
      if (to.meta.index > from.meta.index) {
        this.transitionName = 'slide-right'
      } else {
        this.transitionName = 'slide-left'
      }
    }
  },
  data () {
    return {
      transitionName: ''
    }
  }
}
</script>

<style>
#app {
  width: 100%;
  height: 100%;
}
.slide-right-enter-active, .slide-right-leave-active, .slide-left-enter-active, .slide-left-leave-active {
  will-change: transform;
  transition: all 500ms;
  position: absolute;
}

.slide-right-enter {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}

.slide-right-leave-active {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}

.slide-left-enter {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}

.slide-left-leave-active {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}
</style>
